export default "__VITE_ASSET__ID_Pbhk___"